import HttpCertificateScreen from "../../../../docs/_images/http_certificate.png";
import * as React from 'react';
export default {
  HttpCertificateScreen,
  React
};